// Bottom sheet on phones, centred dialog on larger screens (Radix Dialog for focus and escape handling).
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { cx } from "./primitives";

export function Sheet({ open, onOpenChange, title, description, children, footer, wide }: {
  open: boolean; onOpenChange: (o: boolean) => void; title: string; description?: string; children: ReactNode; footer?: ReactNode; wide?: boolean;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/40 backdrop-blur-[2px] data-[state=open]:animate-[fadeIn_160ms_ease-out]" />
        <Dialog.Content
          aria-describedby={description ? undefined : undefined}
          className={cx(
            "fixed z-50 bg-surface text-ink shadow-sheet outline-none flex flex-col",
            "inset-x-0 bottom-0 max-h-[92dvh] rounded-t-[22px] safe-bottom data-[state=open]:animate-[sheetUp_200ms_cubic-bezier(0.2,0.8,0.2,1)]",
            "md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-[18px] md:max-h-[86dvh]",
            wide ? "md:w-[720px]" : "md:w-[520px]"
          )}
        >
          <div className="mx-auto mt-2 h-1.5 w-10 rounded-full bg-ink/15 md:hidden" aria-hidden />
          <div className="flex items-start justify-between gap-3 px-5 pt-4 pb-2">
            <div>
              <Dialog.Title className="font-display text-[22px] leading-tight">{title}</Dialog.Title>
              {description ? <Dialog.Description className="mt-1 text-muted text-[15px]">{description}</Dialog.Description> : <Dialog.Description className="sr-only">{title}</Dialog.Description>}
            </div>
            <Dialog.Close className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full hover:bg-ink/5" aria-label="Close">
              <X className="h-5 w-5" aria-hidden />
            </Dialog.Close>
          </div>
          <div className="overflow-y-auto px-5 pb-4 flex-1">{children}</div>
          {footer && <div className="border-t border-line px-5 py-3 flex flex-wrap justify-end gap-2">{footer}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
